import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Chip, colors, IconButton, Popover, Stack, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { useState } from 'react';
import { SalesOrderResponseEntity } from 'src/entities/SalesOrder.response.entity';

type Props = {
  value: string;
  entity: SalesOrderResponseEntity;
};

function ApplyStatus({
  value,
  entity,
}: Props) {
  const [popoverAnchorEl, setPopoverAnchorEl] = useState<HTMLElement>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setPopoverAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setPopoverAnchorEl(null);
  };

  const handlePopoverClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
  };

  const { applyStatus, applyErrors } = entity;
  if (!applyStatus) return null;
  let color = 'success';
  if (applyStatus === 'ONGOING') {
    color = 'info';
  } else if (applyStatus === 'FAILED') {
    color = 'error';
  }

  return (
    <Stack direction="row" sx={{ alignItems: 'center' }}>
      <Chip label={value} color={color as 'success' | 'info' | 'error'} />
      {applyStatus === 'FAILED' && applyErrors && applyErrors.length > 0 && (
        <>
          <IconButton
            onClick={handlePopoverOpen}
          >
            <InfoOutlinedIcon sx={{ color: colors.blue[900] }} />
          </IconButton>
          <Popover
            id={popoverAnchorEl ? 'not-alloc-reason-popover' : undefined}
            open={Boolean(popoverAnchorEl)}
            anchorEl={popoverAnchorEl}
            onClose={handlePopoverClose}
            onClick={handlePopoverClick}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
          >
            <Table>
              <TableBody>
                {applyErrors.map((message) => (
                  <TableRow key={[message].join('-')}>
                    <TableCell sx={{ p: 1 }}><Typography noWrap>{message}</Typography></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Popover>
        </>
      )}
    </Stack>
  );
}

export default ApplyStatus;
